import React from 'react';

const Calculator = ({ capID, cashPrice }) => {
  return (
    <div className="container">
      <iframe
        src={`https://newvehicle.com/widgets/lib/finance-comparator-convert/?username=www.omodaauto.co.uk&quoteeUid=9535CEC9-1C42-46B4-09A9-111A449571E7&class=Car&condition=new&vrm=NEW&registrationDate=19%2F12%2F2024&capCode=&capId=${capID}&cashPrice=${cashPrice}&vatIncluded=true&vatQualifying=false&currentOdometerReading=0&vehicleImageUrl=https%3A%2F%2Fomodaauto.co.uk%2Fwp-content%2Fuploads%2F2024%2F07%2FGalena-Silver.webp&cashDepositType=flatRate&cashDeposit=5000&term=48&annualDistance=10000&dateOnForecourt=19%2F12%2F2024&usePersistedOptions=false&origin=https%3A%2F%2Fsales-widget-demo.ivendi.co%2F&widgetId=iv-finance-widget`}
        width="100%"
        height="800"
        title="Finance Calculator"
      ></iframe>
    </div>
  );
};

export default Calculator;
